import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },

    {
        path: 'home',
        loadChildren: () => import('./Page/home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'empleado',
        loadChildren: () => import('./Page/empleado/empleado.module').then(m => m.EmpleadoPageModule)
    },
    {
        path: 'add-empleado/:id',
        loadChildren: () => import('./Page/add-empleado/add-empleado.module').then(m => m.AddEmpleadoPageModule)
    },
    {
        path: 'baja-empleado/:id',
        loadChildren: () => import('./Page/baja-empleado/baja-empleado.module').then(m => m.BajaEmpleadoPageModule)
    },
    {
        path: 'ver-empleado',
        loadChildren: () => import('./Page/ver-empleado/ver-empleado.module').then(m => m.VerEmpleadoPageModule)
    },
    {
        path: 'calendario',
        loadChildren: () => import('./Page/calendario/calendario.module').then(m => m.CalendarioPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./Page/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'add-incapacidad/:id',
        loadChildren: () => import('./Page/add-incapacidad/add-incapacidad.module').then(m => m.AddIncapacidadPageModule)
    },
    {
        path: 'catalogo-empleado',
        loadChildren: () => import('./Modal/catalogo-empleado/catalogo-empleado.module').then(m => m.CatalogoEmpleadoPageModule)
    },
    {
        path: 'permisos',
        loadChildren: () => import('./Page/permisos/permisos.module').then(m => m.PermisosPageModule)
    },
    {
        path: 'adminstracion-parametros',
        loadChildren: () => import('./Page/adminstracion-parametros/adminstracion-parametros.module').then(m => m.AdminstracionParametrosPageModule)
    },
    {
        path: 'permiso-supervisor',
        loadChildren: () => import('./Page/permiso-supervisor/permiso-supervisor.module').then(m => m.PermisoSupervisorPageModule)
    },
    {
        path: 'acceso-app',
        loadChildren: () => import('./Page/acceso-app/acceso-app.module').then(m => m.AccesoAppPageModule)
    },
    {
        path: 'permiso-rh',
        loadChildren: () => import('./Page/permiso-rh/permiso-rh.module').then(m => m.PermisoRHPageModule)
    },
    {
        path: 'permiso-historial',
        loadChildren: () => import('./Page/permiso-historial/permiso-historial.module').then(m => m.PermisoHistorialPageModule)
    },
    {
        path: 'home-office-n1',
        loadChildren: () => import('./Page/home-office-n1/home-office-n1.module').then(m => m.HomeOfficeN1PageModule)
    },
    {
        path: 'home-office-n2',
        loadChildren: () => import('./Page/home-office-n2/home-office-n2.module').then(m => m.HomeOfficeN2PageModule)
    },
    {
        path: 'catalogo-empleado-supervisor',
        loadChildren: () => import('./Modal/catalogo-empleado-supervisor/catalogo-empleado-supervisor.module').then(m => m.CatalogoEmpleadoSupervisorPageModule)
    },
    {
        path: 'comision-trabajo-n1',
        loadChildren: () => import('./Page/comision-trabajo-n1/comision-trabajo-n1.module').then(m => m.ComisionTrabajoN1PageModule)
    },
    {
        path: 'comision-trabajo-n2',
        loadChildren: () => import('./Page/comision-trabajo-n2/comision-trabajo-n2.module').then(m => m.ComisionTrabajoN2PageModule)
    },
    {
        path: 'comision-trabajo-n3',
        loadChildren: () => import('./Page/comision-trabajo-n3/comision-trabajo-n3.module').then(m => m.ComisionTrabajoN3PageModule)
    },
    {
        path: 'historial',
        loadChildren: () => import('./Page/historial/historial.module').then(m => m.HistorialPageModule)
    },
    {
        path: 'expediente',
        loadChildren: () => import('./Page/expediente/expediente.module').then(m => m.ExpedientePageModule)
    },
    {
        path: 'administracion-archivo',
        loadChildren: () => import('./Page/administracion-archivo/administracion-archivo.module').then(m => m.AdministracionArchivoPageModule)
    },
    {
        path: 'subir-archivo-expediente',
        loadChildren: () => import('./Modal/subir-archivo-expediente/subir-archivo-expediente.module').then(m => m.SubirArchivoExpedientePageModule)
    },
    {
        path: 'expediente/:id',
        loadChildren: () => import('./Page/expediente2/expediente2.module').then(m => m.Expediente2PageModule)
    },
    {
        path: 'pirma-vacacional',
        loadChildren: () => import('./Page/pirma-vacacional/pirma-vacacional.module').then(m => m.PirmaVacacionalPageModule)
    },
    {
        path: 'uniforme',
        loadChildren: () => import('./Page/uniforme/uniforme.module').then(m => m.UniformePageModule)
    },
    {
        path: 'evaulacion-desempeno',
        loadChildren: () => import('./Page/evaulacion-desempeno/evaulacion-desempeno.module').then(m => m.EvaulacionDesempenoPageModule)
    },
    {
        path: 'evaulacion2',
        loadChildren: () => import('./Modal/evaulacion2/evaulacion2.module').then(m => m.Evaulacion2PageModule)
    },
    {
        path: 'evaulacion-pregunta',
        loadChildren: () => import('./Modal/evaulacion-pregunta/evaulacion-pregunta.module').then(m => m.EvaulacionPreguntaPageModule)
    },
    {
        path: 'evaulacion-supervisor',
        loadChildren: () => import('./Modal/evaulacion-supervisor/evaulacion-supervisor.module').then(m => m.EvaulacionSupervisorPageModule)
    },
    {
        path: 'capacitacion',
        loadChildren: () => import('./Page/capacitacion/capacitacion.module').then(m => m.CapacitacionPageModule)
    },
    {
        path: 'evaulacion-pregunta-supervisor',
        loadChildren: () => import('./Modal/evaulacion-pregunta-supervisor/evaulacion-pregunta-supervisor.module').then(m => m.EvaulacionPreguntaSupervisorPageModule)
    },
    {
        path: 'horario',
        loadChildren: () => import('./Page/horario/horario.module').then(m => m.HorarioPageModule)
    },
    {
        path: 'permiso-ver-dias-disponibles',
        loadChildren: () => import('./Page/permiso-ver-dias-disponibles/permiso-ver-dias-disponibles.module').then(m => m.PermisoVerDiasDisponiblesPageModule)
    },
    {
        path: 'home-office-n1-a',
        loadChildren: () => import('./Page/home-office-n1-a/home-office-n1-a.module').then(m => m.HomeOfficeN1APageModule)
    },
    {
      path: 'grupos',
      loadChildren: () => import('./Page/grupos/grupos.module').then( m => m.GruposPageModule)
    },
    {
        path: 'grupos-modal',
        loadChildren: () => import('./Modal/grupos-modal/grupos-modal.module').then( m => m.GruposModalPageModule)
    },
    {
        path: 'facturas',
        loadChildren: () => import('./Page/facturas/facturas.module').then( m => m.FacturasPageModule)
    },
    {
        path: 'facturas-autorizar',
        loadChildren: () => import('./Page/facturas-autorizar/facturas-autorizar.module').then( m => m.FacturasAutorizarPageModule)
    },
    {
        path: 'config-facturas',
        loadChildren: () => import('./Page/config-facturas/config-facturas.module').then( m => m.ConfigFacturasPageModule)
    },
    {
        path: 'historial-facturas',
        loadChildren: () => import('./Page/historial-facturas/historial-facturas.module').then( m => m.HistorialFacturasPageModule)
    },
    {
        path: 'nuevo-usuario',
        loadChildren: () => import('./Page/nuevo-usuario/nuevo-usuario.module').then( m => m.NuevoUsuarioPageModule)
    },
    {
        path: 'nuevo-usuario-modal',
        loadChildren: () => import('./Modal/nuevo-usuario-modal/nuevo-usuario-modal.module').then( m => m.NuevoUsuarioModalPageModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
